/**
 * Blog post API endpoints
 */
import { apiGet } from "./client.js";

/**
 * Fetches all blog posts with metadata
 * @returns {Promise<Response>} Blog posts response
 */
export const getBlogPosts = () => apiGet("/blog-posts", { populate: "*" });

/**
 * Fetches a single blog post by slug
 * @param {string} slug - Blog post slug
 * @returns {Promise<Response>} Blog post response
 */
export const getBlogPost = (slug) => apiGet(`/blog-posts/${slug}`, { populate: "*" });

/**
 * Fetches newest blog posts with specified limit
 * @param {number} limit - Maximum number of blog posts to return
 * @returns {Promise<Response>} Newest blog posts response
 */
export const getNewestBlogPosts = (limit = 8) => apiGet("/blog-posts/newest", { limit });